import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseSharedModule } from '@fuse/shared.module';

import { ChatPanelComponent } from 'app/layout/components/chat-panel/chat-panel.component';
import { ProfileProvider } from '../../../../../shared/cw-backend/providers/security/profile/profile.provider';
import { UserListProvider } from '../../../../../shared/cw-backend/providers/security/user/user-list.provider';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogMessageModule } from '../dialog-message/dialog-message.module';

@NgModule({
    declarations: [
        ChatPanelComponent
    ],
    // ChatPanelService saiu daqui: agora e providedIn 'root', uma unica instancia
    // para o app inteiro. Manter aqui criava um segundo HTMLAudioElement.
    providers   : [
        UserListProvider,
        ProfileProvider
    ],
    imports     : [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressBarModule,
        MatTabsModule,
        MatTooltipModule,
        MatRippleModule,
        MatDialogModule,
        DialogMessageModule,
        
        FuseSharedModule
    ],
    exports     : [
        ChatPanelComponent
    ]
})
export class ChatPanelModule
{
}
